export default __webpack_public_path__ + "static/media/default-profile.490ecd9b.svg";